import TaxPage from "./taxPage";
import { useHistory } from "react-router-dom";
import { OnboardingWidget } from "components/OnboardingWidget/OnboardingWidget";
import { useAppSelector } from "hooks/useAppSelector";
import { useDispatch } from "react-redux";
import { closeOnboardingWidget } from "store/slices/onboardingWidget";

export const FilingDetails = (props: {
  isFromServices?: boolean;
  parentRoute?: string;
  addEntityInUrl?: boolean;
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { isOpen: isOnboardingWidgetOpen, product } = useAppSelector(
    (state) => state.onboardingWidget
  );

  const handleBack = () => {
    if (history.length > 1) {
      history.goBack();
    } else {
      window.close();
    }
  };

  return (
    <div className="t-h-screen t-w-full">
      <TaxPage {...props} onClose={handleBack} />
      {isOnboardingWidgetOpen && (
        <OnboardingWidget
          open={isOnboardingWidgetOpen}
          onClose={() => dispatch(closeOnboardingWidget())}
          currentTab={product}
        />
      )}
    </div>
  );
};
